import { render } from "./Old Style.svg?vue&type=template&id=dd3f79bc"
const script = {}
script.render = render

export default script